export const LOGIN = "/login";
export const SIGNUP = "/signup";
export const DASHBOARD = "/";
export const ANALYTICS = "/analytics";

export const DEVICES = "/devices";
export const DEVICES_INFO = "/devices/:selectedDeviceKey";

export const DEVICE_GROUPS = "/deviceGroups";
export const DEVICE_GROUPS_INFO = "/deviceGroups/:selectedGroupKey";

export const MANAGED_APPS = "/managedapps";
export const MANAGED_APPS_INFO = "/managedapps/:selectedKey";

export const EXTERNAL_APPS = "/externalapps";
export const EXTERNAL_APPS_INFO = "/externalapps/:selectedKey";

export const APPBUNDLES = "/appbundles";
export const APPBUNDLES_INFO = "/appbundles/:selectedKey";

export const USERS = "/users";
export const USERS_INFO = "/users/:selectedKey";

export const ORGANIZATIONS = "/organizations";
export const ORGANIZATIONS_INFO = "/organizations/:selectedKey";

export const API_KEYS = "/apiKeys";

export const TERMS = "/termsofservice";
export const PRIVACY_POLICY = "/privacypolicy-01_01_2020.pdf";
export const BRANDING = "/branding";

export const createInfoUrl = (baseURL, key) => baseURL + "/" + key;
